import { render, staticRenderFns } from "./Cesion.vue?vue&type=template&id=78e47267&scoped=true"
import script from "./Cesion.vue?vue&type=script&lang=js"
export * from "./Cesion.vue?vue&type=script&lang=js"
import style0 from "./Cesion.vue?vue&type=style&index=0&id=78e47267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e47267",
  null
  
)

export default component.exports